import { render, staticRenderFns } from "./WorksheetTypeDefinitionCreate.vue?vue&type=template&id=72f50987"
import script from "./WorksheetTypeDefinitionCreate.vue?vue&type=script&lang=js"
export * from "./WorksheetTypeDefinitionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports